export default __webpack_public_path__ + "static/media/confirmation.ee689f44.svg";